import React, { Component } from "react";
import { connect } from "react-redux";

import {
  req_single_eps_customizeConfig,
  req_add_eps_customizeConfig,
  req_delete_eps_customizeConfig,
  req_page_eps_deeds,
  req_page_eps_deeds_customize,
  req_delete_deeds_customize,
} from "../../api";
import {
  Card,
  Button,
  Table,
  Select,
  Input,
  Alert,
  Switch,
  Modal,
  message,
} from "antd";

import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";

import AchievementDeedsTeacherAddModal from "./achievement-deeds-teacher-add-modal";
class AchievementDeedsTeacher extends Component {
  state = {
    loading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "None",
    searchValue: "",
    filterStatus: "",
    customizeStatus: "",
    downItemCode: "DB",
    isAddModal: false,
  };

  UNSAFE_componentWillMount() {
    this.api_customize_config();
    this.api_init_page_items();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.init_columns();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_init_page_items = async (current) => {
    const config = this.api_customize_config();
    config.then((value) => {
      this.current = current; // 保存當前頁，給其他方法可看到
      const { pageSize } = this.state.pagination;
      const {
        customizeStatus,
        searchField,
        searchValue,
        columnSort,
        orderBy,
        filterStatus,
      } = this.state;
      const { token, userCode } = this.props.user;
      this.setState({ loading: true, items: [] });
      console.log("init-customizeStatus:", customizeStatus);
      const result =
        customizeStatus === "ON"
          ? req_page_eps_deeds_customize(
              userCode,
              current,
              pageSize,
              columnSort,
              orderBy,
              searchField,
              searchValue,
              filterStatus,
              token
            )
          : req_page_eps_deeds(
              userCode,
              current,
              pageSize,
              columnSort,
              orderBy,
              searchField,
              searchValue,
              filterStatus,
              token
            );
      this.setState({ loading: false });

      this.switchbar = (
        <Switch
          checkedChildren="自建數據模式"
          unCheckedChildren="系統匯入模式"
          defaultChecked={customizeStatus === "ON" ? true : false}
          onClick={this.handle_check_changed}
        />
      );

      result.then((source) => {
        if (source.total > 0) {
          const { total } = source;
          const items = source.data;
          const pagination = {
            current: this.current,
            pageSize: this.state.pagination.pageSize,
            total,
          };
          this.setState({ items, pagination });
          // console.log(items);
        } else {
          const items = [];
          const pagination = {
            current: 1,
            pageSize: this.state.pagination.pageSize,
            total: 0,
          };
          this.setState({ items, pagination });
        }
      });
    });
  };

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      customizeStatus,
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
    } = this.state;
    const { token, userCode } = this.props.user;
    this.setState({ loading: true, items: [] });
    //console.log("customizeStatus:", customizeStatus);
    console.log("page-customizeStatus:", customizeStatus);
    const result =
      customizeStatus === "ON"
        ? req_page_eps_deeds_customize(
            userCode,
            current,
            pageSize,
            columnSort,
            orderBy,
            searchField,
            searchValue,
            filterStatus,
            token
          )
        : req_page_eps_deeds(
            userCode,
            current,
            pageSize,
            columnSort,
            orderBy,
            searchField,
            searchValue,
            filterStatus,
            token
          );
    this.setState({ loading: false });

    result.then((source) => {
      if (source.total > 0) {
        const { total } = source;
        const items = source.data;
        const pagination = {
          current: this.current,
          pageSize: this.state.pagination.pageSize,
          total,
        };
        this.setState({ items, pagination });
        console.log(items);
      } else {
        const items = [];
        const pagination = {
          current: 1,
          pageSize: this.state.pagination.pageSize,
          total: 0,
        };
        this.setState({ items, pagination });
      }
    });
  };

  api_customize_config = async () => {
    const { token, userCode } = this.props.user;
    const { downItemCode } = this.state;
    const item = {
      BloggerCode: userCode,
      DownItemCode: downItemCode,
    };
    const config = await req_single_eps_customizeConfig(item, token);
    const { CustomizeStatus } = config;
    this.setState({ customizeStatus: CustomizeStatus });
    return config;
  };

  api_customize_config_edit = async () => {
    const { token, userCode } = this.props.user;
    const { customizeStatus } = this.state;
    console.log("new", customizeStatus);
    const config = {
      BloggerCode: userCode,
      DownItemCode: "DB",
      CustomizeStatus: customizeStatus,
    };
    if (customizeStatus === "ON") {
      await req_add_eps_customizeConfig(config, token);
    } else {
      await req_delete_eps_customizeConfig(
        config.BloggerCode,
        config.DownItemCode,
        token
      );
    }
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_deeds_customize(key, token);

    if (result.status === "success") {
      message.success("刪除成功");
      this.handle_data_refresh();
    } else {
      //console.log(result)
    }
  };
  // 數據配置設定 //////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "分類",
        dataIndex: "SubCategoryName",
        width: 60,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.2em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "項目內容",
        dataIndex: "EventTitle",
        width: 150,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "登錄時間",
        width: 60,
        render: (item) => {
          const { EventDatetime } = item;
          const { customizeStatus } = this.state;
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {EventDatetime}</span>
              {customizeStatus === "ON" ? (
                <button
                  type="button"
                  className="btn btn-outline-dark btn-sm"
                  onClick={() => this.handle_show_ui_modal("delete", item)}
                >
                  <i className="fas fa-minus"></i>
                  <span> 刪除</span>
                </button>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_check_changed = () => {
    const tag = this.state.customizeStatus;
    const customizeStatus = tag === "OFF" ? "ON" : "OFF";
    this.status = customizeStatus === "ON" ? true : false;
    this.setState({ customizeStatus }, () => {
      this.setState({ items: [] });
      // 1.設定值回寫
      this.api_customize_config_edit();
      // 2.刷新頁面
      this.api_page_items(this.current);
    });
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true });
        break;
      case "delete":
        const { Uid } = item;
        console.log(item);
        Modal.confirm({
          title: `您確定刪除此筆數據`,
          onOk: () => {
            this.api_delete_item(Uid);
          },
        });
        break;
      case "download":
        break;
      default:
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  /////////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      customizeStatus,
      isAddModal,
    } = this.state;
    const title = (
      <span>
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="None">搜索條件</Select.Option>
          <Select.Option value="EventTitle">項目內容</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 150, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        {customizeStatus === "ON" ? (
          <Button
            type="primary"
            onClick={() => this.handle_show_ui_modal("add", "")}
          >
            <i className="fas fa-plus"></i>
            <span style={{ marginLeft: "4px" }}>增加</span>
          </Button>
        ) : (
          ""
        )}
        <div>{this.switchbar}</div>
      </span>
    );
    const extra = (
      <Alert message="資料來源：研究管理系統" type="info" showIcon />
    );
    return (
      <Card title={title} extra={extra}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Id"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isAddModal}
          width={600}
          onOk={() => {
            this.setState({ isAddModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isAddModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
          okText="關閉"
        >
          <AchievementDeedsTeacherAddModal />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(AchievementDeedsTeacher);
